import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import { createPinia } from 'pinia'

// Import your global stylesheet here
import '@/assets/style.css'

createApp(App).use(store).use(router).use(ToastPlugin).use(createPinia()).mount('#app')
